module.exports = __webpack_public_path__ + "static/img/tb5.7329e931.jpg";